import RequestDemoForm from '../components/RequestDemoForm/RequestDemoForm';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './RequestDemoPage.module.css';

function RequestDemoPage() {
  usePageTitle('Request Demo');

  return (
    <section className={styles.page}>
      <div className={`container ${styles.inner}`}>
        <span className="sectionLabel">Request Demo</span>
        <h1 className={styles.title}>See ONI in action at your venue</h1>
        <p className={styles.subtitle}>
          Tell us about your stadium or arena and we will reach out to schedule a personalized demo.
        </p>
        <RequestDemoForm />
      </div>
    </section>
  );
}

export default RequestDemoPage;
